import { useMemo } from 'react';

import { Box, useTheme } from '@material-ui/core';

import { MEDIA_TYPES } from 'constants/mediaTypes';
import FileCategory from 'pages/Contatos/components/FileCategory';
import { useAppSelector } from 'store';
import {
  AtendimentoInterfaceV2,
  atendimentosSelector,
} from 'store/reducers/atendimentos';

interface TabPanelArquivosProps {
  contatoId: string;
}

export default function TabPanelArquivos({ contatoId }: TabPanelArquivosProps) {
  const theme = useTheme();
  const { historicoAtendimentoSelecionado } =
    useAppSelector(atendimentosSelector);

  const atendimento = useMemo(
    () => historicoAtendimentoSelecionado as AtendimentoInterfaceV2,
    [historicoAtendimentoSelecionado],
  );

  const channelCode = atendimento?.channel?.code ?? '';

  return (
    <Box display="flex" flexDirection="column">
      <Box>
        {MEDIA_TYPES.map(mediaType => (
          <FileCategory
            key={mediaType.key}
            mediaType={mediaType}
            color={theme.palette[mediaType.colorKey].main}
            contatoId={contatoId}
            canalId={channelCode}
          />
        ))}
      </Box>
    </Box>
  );
}
